import React from 'react';
import PropTypes from 'prop-types';

const StepContactLocation = ({ data, onChange }) => {
  const cities = [
    'Mumbai', 'Delhi', 'Bangalore', 'Chennai', 'Kolkata', 
    'Pune', 'Hyderabad', 'Jaipur', 'Ahmedabad', 'Surat'
  ];

  const countryCodes = [
    { code: '+91', country: 'India' },
    { code: '+1', country: 'USA' },
    { code: '+44', country: 'UK' },
    { code: '+971', country: 'UAE' }
  ];

  const handleChange = (field, value) => {
    onChange({ ...data, [field]: value });
  };

  const handlePhoneChange = (field, countryCode, number) => {
    onChange({ ...data, [field]: `${countryCode}${number}` });
  };

  const parsePhoneNumber = (phoneString) => {
    if (!phoneString) return { countryCode: '+91', number: '' };
    
    for (const code of countryCodes) {
      if (phoneString.startsWith(code.code)) {
        return {
          countryCode: code.code,
          number: phoneString.substring(code.code.length)
        };
      }
    }
    return { countryCode: '+91', number: phoneString };
  };

  const contactPhone = parsePhoneNumber(data.contactNumber);
  const whatsappPhone = parsePhoneNumber(data.whatsappNumber || '+919510682249');

  return (
    <div className="step-card contact-location-step">
      <div className="form-row">
        <div className="form-group half-width">
          <label htmlFor="city" className="required-field">City</label>
          <select
            id="city"
            value={data.city || ''}
            onChange={(e) => handleChange('city', e.target.value)}
            className="form-input"
          >
            <option value="">Select city</option>
            {cities.map(city => (
              <option key={city} value={city}>{city}</option>
            ))}
          </select>
        </div>

        <div className="form-group half-width">
          <label htmlFor="area" className="required-field">Area/Locality</label>
          <input
            type="text"
            id="area"
            value={data.area || ''}
            onChange={(e) => handleChange('area', e.target.value)}
            placeholder="e.g., Bandra West"
            className="form-input"
          />
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="fullAddress" className="required-field">Full Address</label>
        <textarea
          id="fullAddress"
          value={data.fullAddress || ''}
          onChange={(e) => handleChange('fullAddress', e.target.value)}
          placeholder="Enter complete address with landmarks"
          className="form-textarea"
          rows="3"
        />
      </div>

      <div className="form-row">
        <div className="form-group half-width">
          <label htmlFor="contactNumber" className="required-field">Contact Number</label>
          <div className="phone-input-group">
            <select
              value={contactPhone.countryCode}
              onChange={(e) => handlePhoneChange('contactNumber', e.target.value, contactPhone.number)}
              className="country-code-select"
            >
              {countryCodes.map(code => (
                <option key={code.code} value={code.code}>
                  {code.code}
                </option>
              ))}
            </select>
            <input
              type="tel"
              value={contactPhone.number}
              onChange={(e) => handlePhoneChange('contactNumber', contactPhone.countryCode, e.target.value)}
              placeholder="9876543210"
              className="phone-number-input"
            />
          </div>
        </div>

        <div className="form-group half-width">
          <label htmlFor="whatsappNumber" className="required-field">WhatsApp Number</label>
          <div className="phone-input-group">
            <select
              value={whatsappPhone.countryCode}
              onChange={(e) => handlePhoneChange('whatsappNumber', e.target.value, whatsappPhone.number)}
              className="country-code-select"
            >
              {countryCodes.map(code => (
                <option key={code.code} value={code.code}>
                  {code.code}
                </option>
              ))}
            </select>
            <input
              type="tel"
              value={whatsappPhone.number}
              onChange={(e) => handlePhoneChange('whatsappNumber', whatsappPhone.countryCode, e.target.value)}
              placeholder="9876543210"
              className="phone-number-input"
            />
          </div>
        </div>
      </div>

      <div className="form-row">
        <div className="form-group half-width">
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            id="email"
            value={data.email || ''}
            onChange={(e) => handleChange('email', e.target.value)}
            placeholder="business@example.com"
            className="form-input"
          />
        </div>

        <div className="form-group half-width">
          <label htmlFor="website">Website URL (optional)</label>
          <input
            type="url"
            id="website"
            value={data.website || ''}
            onChange={(e) => handleChange('website', e.target.value)}
            placeholder="https://yourbusiness.com"
            className="form-input"
          />
        </div>
      </div>
    </div>
  );
};

StepContactLocation.propTypes = {
  data: PropTypes.shape({
    city: PropTypes.string,
    area: PropTypes.string,
    fullAddress: PropTypes.string,
    contactNumber: PropTypes.string,
    whatsappNumber: PropTypes.string,
    email: PropTypes.string,
    website: PropTypes.string
  }).isRequired,
  onChange: PropTypes.func.isRequired
};

export default StepContactLocation;
